export const FETCH_STONE_COLOR_REQUEST = 'FETCH_STONE_COLOR_REQUEST';
export const FETCH_STONE_COLOR_SUCCESS = 'FETCH_STONE_COLOR_SUCCESS';
export const FETCH_STONE_COLOR_FAILURE = 'FETCH_STONE_COLOR_FAILURE';

export const ADD_STONE_COLOR_REQUEST = 'ADD_STONE_COLOR_REQUEST';
export const ADD_STONE_COLOR_SUCCESS = 'ADD_STONE_COLOR_SUCCESS';
export const ADD_STONE_COLOR_FAILURE = 'ADD_STONE_COLOR_FAILURE';

export const UPDATE_STONE_COLOR_REQUEST = 'UPDATE_STONE_COLOR_REQUEST';
export const UPDATE_STONE_COLOR_SUCCESS = 'UPDATE_STONE_COLOR_SUCCESS';
export const UPDATE_STONE_COLOR_FAILURE = 'UPDATE_STONE_COLOR_FAILURE';

export const DELETE_STONE_COLOR_REQUEST = 'DELETE_STONE_COLOR_REQUEST';
export const DELETE_STONE_COLOR_SUCCESS = 'DELETE_STONE_COLOR_SUCCESS';
export const DELETE_STONE_COLOR_FAILURE = 'DELETE_STONE_COLOR_FAILURE';

export const STONE_COLOR_FORM_ERROR = 'STONE_COLOR_FORM_ERROR';
export const STONE_COLOR_FORM_SUCCESS = 'STONE_COLOR_FORM_SUCCESS';
export const SET_STONE_COLOR_EDIT = 'SET_STONE_COLOR_EDIT';
export const CLEAR_STONE_COLOR_EDIT = 'CLEAR_STONE_COLOR_EDIT'; 